var onRuntimeError = function () {
    var _a, _b;
    var runtimeError = new Error('Alerts - Runtime error');
    (_b = (_a = window.newrelic) === null || _a === void 0 ? void 0 : _a.noticeError) === null || _b === void 0 ? void 0 : _b.call(_a, runtimeError);
};
export default onRuntimeError;
